const QR_HARDCODED_YPF = [
  {
    url: "https://www.mercadopago.com/instore/merchant/qr/82261852/72f7f87d46b3556cbcc9e.png",
    posi: 11,
  },
];

const getQRs = async () => {
  return QR_HARDCODED_YPF;
};

const qrs = {
  getQRs,
};

export default qrs;
